/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetLoadCarrierTemplatesResponse } from '../../models/get-load-carrier-templates-response';
import { KeyType } from '../../models/key-type';

export interface GetLoadCarrierTemplates$Params {
  organizationKey: KeyType;
}

export function getLoadCarrierTemplates(http: HttpClient, rootUrl: string, params: GetLoadCarrierTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLoadCarrierTemplatesResponse>> {
  const rb = new RequestBuilder(rootUrl, getLoadCarrierTemplates.PATH, 'get');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetLoadCarrierTemplatesResponse>;
    })
  );
}

getLoadCarrierTemplates.PATH = '/organizations/{organizationKey}/load-carrier-templates';
